import React, { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import "./sort-by-select.scss";

import check from "../../../../assets/icons/Icon - Checkmark.svg";
import downArrow from "../../../../assets/icons/Icon - Chevron - Down.svg";

const Toggle = React.forwardRef(({ children, onClick }, ref) => (
  <a
    href=""
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    className="select-toggle"
  >
    {children}
  </a>
));

const SortBySelect = ({ value, 
                        handleSelect, 
                        options, 
                        type }) => {
  const [show, setShow] = useState(false);

  return (
    <Dropdown className="dashboard-widget-select" onBlur={() => setShow(false)}>
      <Dropdown.Toggle as={Toggle}>
        <div className="dropdown-title" onClick={() => setShow(!show)}>
          {value}
          <div className="arrow-padding">
            <img src={downArrow} className={`${show ? "arrow-up" : ""}`}></img>
          </div>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <div className={`custom-select custom-select-width-${type}`}>
          {options.map((option, index) => (
            <Dropdown.Item
              eventKey={option}
              onSelect={handleSelect}
              className="custom-select-option custom-select-option-height-1 option-padding"
              key={option}
            >
              <span
                className={`custom-select-text ${
                  value === option ? "selected-text" : "unselected-text"
                } flex-grow-1`}
              >
                {option}
              </span>
              {value === option ? <img src={check}></img> : ""}
              <hr
                className={`custom-hr ${
                  index === options.length - 1 ? "border-0" : ""
                }`}
              />
            </Dropdown.Item>
          ))}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SortBySelect;
